import { useEffect, type RefObject } from 'react';

/** Imperative sticky shop bar — no React re-renders on scroll. */
export function useHomeStickyBar(
  barRef: RefObject<HTMLElement | null>,
): void {
  useEffect(() => {
    const bar = barRef.current;
    if (!bar) return;

    let visible = false;
    let ticking = false;

    const apply = () => {
      ticking = false;
      const next = window.scrollY > 50;
      if (next === visible) return;
      visible = next;
      bar.dataset.visible = next ? '1' : '0';
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(apply);
    };

    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [barRef]);
}
